<div class="cssWidgetWrapper" fxLayout="column">
    <dx-data-grid
        #gridDettaglioLm35
        [rowAlternationEnabled]="true"
        [columnAutoWidth]="true"
        [filterRow]="true"
        [dataSource]="contributiVersati"
        [allowColumnReordering]="true"
        [showBorders]="true"
        height="300px"
        [wordWrapEnabled]="true"
        [loadPanel]="{ enabled: true }">
        <dxi-column dataField="descrizione"> </dxi-column>
        <dxi-column alignment="right" dataField="importo" cellTemplate="importoTemplate">
            <div *dxTemplate="let importoAcreditoTemplate of 'importoTemplate'">
                {{
                    importoAcreditoTemplate.data.importo?.toLocaleString('it-IT', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2
                    })
                }}
            </div>
        </dxi-column>

        <dxo-summary>
            <dxi-total-item column="importo" [customizeText]="totaleImportoFormat" summaryType="sum"> </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
